<template>
  <div v-if="resolvedComponent" class="interaction-host">
    <component
      :is="resolvedComponent"
      :cards="cards"
      :resolved="resolution"
      :superseded="superseded"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getInteraction } from "@/components/OliverBotV2/interactions/registry";
// Side-effect import: registers all interaction types.
import "@/components/OliverBotV2/interactions";

export default {
  name: "InteractionHost",
  props: {
    /** The message's `interactions`: the card, drawn by the component its `type` names. */
    interactions: {
      type: Array,
      required: true,
    },
    conversationId: {
      type: String,
      default: null,
    },
    /** The answer history shows this card was given: the card is drawn answered. */
    resolution: {
      type: Object,
      default: null,
    },
    /**
     * True when a newer message exists after this card — the user moved on
     * without answering, so the card is locked into an "ignored" state.
     */
    superseded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cards() {
      return this.interactions || [];
    },
    type() {
      return this.cards[0]?.type || null;
    },
    /** The card's component, when its type accepts the card as saved; any other is left out. */
    resolvedComponent() {
      const def = this.type ? getInteraction(this.type) : null;
      return def && def.accepts(this.cards[0]) ? def.component : null;
    },
  },
  methods: {
    ...mapActions("oliverChatBotV2", ["answerInteraction"]),
    /** `{text, response}`: the card's answer as the clinician's message and as c3 reads it. */
    onSubmit(answer) {
      this.answerInteraction({ chatId: this.conversationId, ...answer });
      this.$emit("answered");
    },
  },
};
</script>
